import { BookingJourneyState } from "store/bookingJourney";

export enum CategoryCode {
  Required = "MyLearning",
  Recommended = "Recommendations",
  Popular = "Popular",
  MyInterest = "Playlist",
  Channel = "Channel",
  ParentPathway = "ParentPathway",
  All = "All",
}

export type SortTypeAlphabeticalAscending = "SORT_ALPHABETICAL_ASCENDING";
export type SortTypeAlphabeticalDescending = "SORT_ALPHABETICAL_DESCENDING";
export type SortTypeDurationAscending = "SORT_DURATION_ASCENDING";
export type SortTypeDurationDescending = "SORT_DURATION_DESCENDING";
export type SortTypePriceAscending = "SORT_PRICE_ASCENDING";
export type SortTypePriceDescending = "SORT_PRICE_DESCENDING";
export type SortTypeNone = "SORT_NONE";
export type SortTypeDefault = "SORT_DEFAULT";

export type SortType =
  | SortTypeAlphabeticalAscending
  | SortTypeAlphabeticalDescending
  | SortTypeDurationAscending
  | SortTypeDurationDescending
  | SortTypePriceAscending
  | SortTypePriceDescending
  | SortTypeNone
  | SortTypeDefault;

export type ProfileFieldTypeSingleLineText = "SingleLineText";
export type ProfileFieldTypeNumber = "number";
export type ProfileFieldTypeSingleSelectDropdown = "SingleSelectDropdown";
export type ProfileFieldType =
  | ProfileFieldTypeSingleLineText
  | ProfileFieldTypeNumber
  | ProfileFieldTypeSingleSelectDropdown;

export type EnrollmentStepTypeWorkshops = "WORKSHOPS";
export type EnrollmentStepTypeEnrollee = "ENROLLEE";
export type EnrollmentStepTypeTerms = "TERMS";
export type EnrollmentStepTypePrerequisites = "PREREQUISITES";
export type AdminEnrollStep = "ADMIN_ENROLL";
export type AdminConfirmStep = "ADMIN_CONFIRM";
export type EnrollmentStepType =
  | EnrollmentStepTypeWorkshops
  | EnrollmentStepTypeEnrollee
  | EnrollmentStepTypeTerms
  | EnrollmentStepTypePrerequisites
  | AdminConfirmStep
  | AdminEnrollStep;

export const enum PathwayType {
  playlist = "playlist",
  channel = "channel",
  pathway = "pathway",
  parentpathway = "parentpathway",
}

export interface TabModel<T> {
  label: string;
  isDirty?: boolean | undefined;
  tabId?: string;
  tabPath?: string;
  value?: T;
}

export enum ProfileTabId {
  ProfileDetails = "profile_details",
  TopicOfInterest = "my_topics_of_interest",
  MyTeam = "my_team",
  ProfileReport = "profile_report_tab",
  MyCalendar = "my_calendar",
  MySkills = "my_skills",
}

export enum BookingJourneyStep {
  "Summary" = "Summary",
  "DateAndLocation" = "DateAndLocation",
  "HostDelegatesPage" = "HostDelegatesPage",
  "Payment" = "Payment",
  "Review" = "Review",
  "Complete" = "Complete",
}

export enum DeliveryMethod {
  "BlendedIncludingF2Fworkshop" = "Blended, including F2F workshop",
  "BlendedIncludingVLE" = "Blended, including VLE",
  "ConferenceCall" = "Conference call",
  "F2FOnly" = "F2F only",
  "VirtualLearningEnvironment" = "Virtual learning environment",
  "DigitalOnly" = "Digital Only",
}

export interface WizardStep {
  handleMoveNext?: (state: BookingJourneyState) => BookingJourneyState;
  handleMoveBack?: (state: BookingJourneyState) => BookingJourneyState;
  skip?: (state: BookingJourneyState) => boolean;
}
export type WizardSteps = { [id in BookingJourneyStep]: WizardStep };

export interface LearningSection {
  title: any;
  code: CategoryCode;
}

export interface ILazyLoadableComponent {
  onLoadingDataChanged?: (loading: boolean) => void;
  loadData?: boolean;
}

export interface Menu {
  id: string;
  name: string;
}

export interface MenuData {
  header: string;
  menuList: Menu[];
}

export enum CreationMethod {
  None = 0,
  BookingPortal = 1,
  Ibf = 2,
}

export enum SessionSortFields {
  Location = "location",
  SeatsAvailable = "noOfSeatsAvailable",
  StartDate = "startDateTime",
  EndDate = "endDateTime",
  AddressLine1 = "addressLine1",
  PostCode = "postcode",
}
export type SortableTableHeaderType = {
  name?: string;
  header?: string;
  align?: "inherit" | "left" | "center" | "right" | "justify";
  isAscending?: boolean;
  isSortable: boolean;
};
export type DateFieldConfig = {
  field: any;
  elementId: string;
  ariaLabelId: string;
  label?: string;
  isMonth?: boolean;
  showLabel?: boolean;
  rootClass?: string;
  errorMessageLabel?: string;
};

export type DateFieldMapConfig = {
  [key: string]: {
    dateTypeFieldConfig: DateFieldConfig[];
    bookingJourneyGridLabel: string;
  };
};

export enum NewLearningRequestStep {
  NewLearning = 0,
  LearningAnalysis = 1,
  CourseDetails = 2,
  BudgetCheck = 3,
  Recommendations = 4,
  CommissioningDetails = 5,
  RequestSubmitted = 6,
}

export enum ProcurementRoute {
  Central = "central",
  Local = "local",
}

export enum WorkflowStageEnum {
  Completed = "Completed",
  Cancelled = "Cancelled",
  Failed = "Failed",
  FailedToSubmitToAppian = "FailedToSubmitToAppian",
  Initial = "Initial",
  CourseDetailSubmitted = "CourseDetailSubmitted",
  BudgetCheck = "BudgetCheck",
  TnaAnswersSubmitted = "TnaAnswersSubmitted",
  AwaitingRecommendation = "AwaitingRecommendation",
  AwaitingUserAcceptance = "AwaitingUserAcceptance",
  UserRecommendationsDecisionSubmitted = "UserRecommendationsDecisionSubmitted",
  AwaitingNlrAnswers = "AwaitingNlrAnswers",
  NlrAnswersSubmitted = "NlrAnswersSubmitted",
  SubmittingToAppian = "SubmittingToAppian",
}
